var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contacts',{attrs:{"data":_vm.getListContactByBranch.data,"pagination":_vm.getListContactByBranch.pagination,"fetch-callback":_vm.ListContactByBranch,"ids":{ branch_id: _vm.$route.params.sucursal_id },"entity":"branches"}})}
var staticRenderFns = []

export { render, staticRenderFns }